import { F, G } from "@mobily/ts-belt";
import * as React from "react";
import { useDebounce } from "../../hooks";
import trackSearchEvent from "../../util/searchTracking";
import { defaultFilter, removeEmptyFilterKeys, useFilterParams } from "./utils";
import ActiveFilters from "./components/ActiveFilters";
import FilterPanel from "./components/FilterPanel";
import ProductGrid from "./components/ProductGrid";
import SearchBar from "./components/SearchBar";
import SortSelect from "./components/SortSelect";
import s from "./BrowseProducts.module.css";

const FilterIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="7" y1="12" x2="17" y2="12" />
    <line x1="10" y1="18" x2="14" y2="18" />
  </svg>
);

export default function BrowseProducts() {
  const [showFilters, setShowFilters] = React.useState(false);
  const { filter, setFilter } = useFilterParams();

  useDebounce(
    () => {
      if (G.isObject(filter) && !F.equals(defaultFilter, filter)) {
        trackSearchEvent({
          action: "search-products",
          payload: removeEmptyFilterKeys(filter),
        });
      }
    },
    320,
    [filter],
  );

  const activeSignedTypes = Object.keys(filter.signedType || {}).filter(
    (key) => filter.signedType[key],
  );

  return (
    <div className={s.page}>
      <header>
        <h1 className={s.pageTitle}>Browse Products</h1>
      </header>

      <div
        className={s.toolbar}
        role="search"
        aria-label="Product search and sort"
      >
        <div className={s.searchWrap}>
          <SearchBar filter={filter} setFilter={setFilter} />
        </div>

        <div className={s.toolbarActions}>
          <SortSelect filter={filter} setFilter={setFilter} />

          <button
            type="button"
            className={s.filterToggleBtn}
            onClick={() => setShowFilters((prev) => !prev)}
            aria-expanded={showFilters}
            aria-controls="filter-panel"
          >
            <FilterIcon />
            {showFilters ? "Hide Filters" : "Show Filters"}
          </button>
        </div>
      </div>

      {activeSignedTypes.length > 0 && (
        <div className={s.activeFiltersRow}>
          <ActiveFilters filter={filter} setFilter={setFilter} />
        </div>
      )}

      <div className={s.layout}>
        <FilterPanel
          filter={filter}
          setFilter={setFilter}
          showFilters={showFilters}
        />

        <div>
          <ProductGrid filter={filter} setFilter={setFilter} />
        </div>
      </div>
    </div>
  );
}
